import { IconWithTooltip } from '@/features/maintenance-data/components/IconWithTooltip';
import { MaintenanceDataItem } from '@/generated/GeneratedApiTypes';

const STATUS_TOOLTIP_PREFIX = 'intl-msg:vehicle-diagnostics.maintenance.table.maintenance-data.status';

const SeverityIcon = ({ status }: { status: MaintenanceDataItem['status'] }) => {
    switch (status) {
        case 'OVERDUE':
            return (
                <IconWithTooltip
                    iconClass="rioglyph rioglyph-error-sign text-color-danger"
                    tooltipKey={`${STATUS_TOOLTIP_PREFIX}.overdue`}
                    ariaLabel="Overdue"
                />
            );
        case 'DUE':
            return (
                <IconWithTooltip
                    iconClass="rioglyph rioglyph-warning-sign text-color-warning"
                    tooltipKey={`${STATUS_TOOLTIP_PREFIX}.almost-due`}
                    ariaLabel="Almost due"
                />
            );
        case 'UNKNOWN':
            return (
                <IconWithTooltip
                    iconClass="rioglyph rioglyph-question-sign text-color-gray"
                    tooltipKey={`${STATUS_TOOLTIP_PREFIX}.unknown`}
                    ariaLabel="Unknown"
                />
            );
        default:
            return null;
    }
};

export const StatusCell = ({ row }: { row: MaintenanceDataItem }) => (
    <td data-field="status">
        <SeverityIcon status={row.status} />
        {row.solved_by_customer && (
            <IconWithTooltip
                iconClass="rioglyph rioglyph-series text-color-info margin-left-5"
                tooltipKey={`${STATUS_TOOLTIP_PREFIX}.solved-by-customer`}
                ariaLabel="Solved by customer"
            />
        )}
    </td>
);
